export const androidUrl = "https://play.google.com/store/apps/details?id=com.fresalabs.propertytroop"